import {
  Button,
  Col,
  Input,
  Modal,
  QRCode,
  Row,
  Select,
  Typography,
} from "antd";
import "./filterSelect.scss";
import React, { useEffect, useState } from "react";
import { HandleErrors } from "../../utils/handleErrors";
import { getDistinctValuesService } from "../../services/event.service";

interface Props {
  fieldName: string;
  value: string
  onChange: (data: any) => void;
  showAll?: boolean
}

export const FilterSelect: React.FC<Props> = (props) => {
  const [options, setOptions] = useState<any[]>([]);
  
  const [value, setValue] = useState("")

  useEffect(() => {
    setValue(props.value);
  }, [props.value]);

  useEffect(() => {
    getOptions(props.fieldName);
  }, [props.fieldName]);

  const getOptions = async (filedName: string) => {
    try {
      const res = await getDistinctValuesService(filedName);

      const temp = [];
      for (const i of res) {
        temp.push({
          value: i,
          label: i,
        });
      }

      if(props.showAll){
        setOptions([
          {value: "", label: "همه"},
          ...temp
        ]);
      }else{
        setOptions(temp);
      }
      
    } catch (error) {
      HandleErrors(error);
    }
  };

  return (
    <div className="FilterSelect">
      <Select
        size="large"
        variant="filled"
        value={value}
        onChange={(e) => {props.onChange(e)}}
        options={options}
      />
    </div>
  );
};
